"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reopening = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const provider_1 = require("@cart/provider");
const modal_1 = __importDefault(require("@kawaui/modal"));
const react_1 = require("react");
const choice_1 = require("./components/choice");
const new_choice_1 = require("./components/new-choice");
const Styled = __importStar(require("./styles/reopening"));
const NEW_ORDER_VALUE = -1;
const defaultI18n = (key) => key;
const Reopening = ({ onValidate, ordersToReopen, productId, quantity, cartType, i18n = defaultI18n }) => {
    const [selectedOrder, setSelectedOrder] = (0, react_1.useState)(null);
    const { reopenCartConnected: reopen } = (0, provider_1.useCartActions)();
    const handleOrderSelect = (event) => {
        setSelectedOrder(Number(event.target.value));
    };
    const handleValidate = () => {
        if (selectedOrder) {
            onValidate && onValidate(selectedOrder);
            const orderToReopen = { order_id: selectedOrder === NEW_ORDER_VALUE ? null : selectedOrder };
            reopen(productId, quantity, cartType, orderToReopen);
        }
    };
    return ((0, jsx_runtime_1.jsx)(modal_1.default, { disableBackdropEvents: true, open: true, children: (0, jsx_runtime_1.jsxs)(Styled.Container, { children: [(0, jsx_runtime_1.jsx)(Styled.ModalTitle, { children: i18n('order_reopening.modal.title') }), (0, jsx_runtime_1.jsxs)(Styled.OrderChoiceGroup, { onChange: handleOrderSelect, value: selectedOrder ? String(selectedOrder) : undefined, fullWidth: true, children: [ordersToReopen &&
                            ordersToReopen.map(({ order_id, creation_date }) => ((0, jsx_runtime_1.jsx)(choice_1.OrderChoice, { isActive: selectedOrder === order_id, onSelect: setSelectedOrder, orderId: order_id, orderDate: creation_date, i18n: i18n }, order_id))), (0, jsx_runtime_1.jsx)(new_choice_1.NewOrderChoice, { i18n: i18n, isActive: selectedOrder === NEW_ORDER_VALUE, onSelect: setSelectedOrder, value: NEW_ORDER_VALUE })] }), (0, jsx_runtime_1.jsx)(Styled.ValidateButton, { disabled: selectedOrder === null, size: "large", variant: "primary", onClick: handleValidate, children: i18n('order_reopening.modal.confirm.cta') })] }) }));
};
exports.Reopening = Reopening;
exports.default = exports.Reopening;
